import axios from ".";

/** List initiatives filtered by status/year. */
export const getAllInitiative = (params?: any) => {
  return axios({
    method: "POST",
    url: "/initiative",
    params: {
      year: params.year ? params.year : undefined,
    },
    data: {
      status: params.status ? params.status : null,
      departments: params.departments ? params.departments : null,
    },
  });
};

/** Get a single initiative by id. */
export const getInitiativeById = (id: any) => {
  return axios({
    method: "GET",
    url: `/initiative/${id}`,
  });
};
/** Delete initiative by id. */
export const deleteInitiativeById = (id: any) => {
  return axios({
    method: "DELETE",
    url: `/initiative/delete/${id}`,
  });
};

/** Create a new initiative. */
export const addInitiative = (data: any) => {
  return axios({
    method: "POST",
    url: `/initiative/create-initiative`,
    data: data,
  });
};

/** Update initiative by id. */
export const updateInitiative = (id: number, data?: any) => {
  return axios({
    method: "PUT",
    url: `/initiative/update/${id}`,
    data: data,
  });
};

/** Get Key Result by id. */
export const getKeyResultById = (id: any) => {
  return axios({
    method: "GET",
    url: `/key-results/${id}`,
  });
};

/** Update Key Result by id. */
export const updateKeyResult = (id: number, data?: any) => {
  return axios({
    method: "PUT",
    url: `/key-results/${id}`,
    data: data,
  });
};

/** Get initiative discussion comments by id. */
export const getCommentsById = (id: any) => {
  return axios({
    method: "GET",
    url: `/initiative/comments/${id}`,
  });
};

/** Add a comment to an initiative. */
export const addComment = (data: any) => {
  return axios({
    method: "POST",
    url: `/initiative/add/comment`,
    data: data,
  });
};

export const getDepartmentOwners = () => {
  return axios({
    method: "GET",
    url: `/role-management/department-owners/1`,
  });
};
